import { motion } from 'framer-motion';
import { Colors } from '~/themes/colors';
import CustomSpinner from '../CustomSpinner';
import { Text } from '../Text';
import { IOptionValue, TValueChangeCallback } from './interfaces';

interface IProps<T> {
  data: IOptionValue<T>[];
  isSearching: boolean;
  onChange: TValueChangeCallback<T>;
}

export const OptionList = <T,>({ data, isSearching, onChange }: IProps<T>) => {
  if (isSearching) {
    return <CustomSpinner isLoading={true} size={16} />;
  }

  if (data.length === 0) {
    return (
      <Text color={Colors.neutral_500} fontSize={14} textAlign="center">
        No results found
      </Text>
    );
  }

  return (
    <>
      {data.map((it) => (
        <motion.div
          className="options-item"
          data-value={it.value}
          key={it.value as any}
          onClick={() => onChange(it)}
        >
          <Text color="inherit">{it.label}</Text>
        </motion.div>
      ))}
    </>
  );
};
